import { Button, ButtonProps } from '@mui/material'

const GenericButton: React.FC<ButtonProps> = ({
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  ...props
}) => {
  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      {...props}
      sx={{
        ...(props.sx || {}),
      }}
    />
  )
}

export default GenericButton
